import "./CustomSwitch.css";

interface Props {
  isActive: boolean;
  names: string;
  handleClick: (v: string) => void;
  displayType?: 'yesno' | 'onoff'; 
}

export default function CustomSwitch(props: Props) {
  const { isActive, names, handleClick, displayType = 'onoff' } = props;  

  return (
    <div
      className={`${
        names === "isAmpVantageActive" ? "ampSwitch" : ""
      } custom-switch`}
    >
      <input
        type="checkbox"
        checked={isActive}
        id={names}
        readOnly
        onClick={() => handleClick(names)}
      />
      <label htmlFor={names} className="switch-label">
        <span className="switch-button"></span>
        <span className="switch-on">{displayType === 'yesno' ? 'YES' : 'ON'}</span>
        <span className="switch-off">{displayType === 'yesno' ? 'NO' : 'OFF'}</span>
      </label>
    </div>
  );
}